import { z } from "zod";

import { registerSchema } from "./register.schema";

export enum UserType {
  ADVERTISER = "ADVERTISER",
  PARTNER = "PARTNER",
  BOTH = "BOTH",
}

export interface IRegisterRequest {
  email: string;
  password: string;
  name: string;
  userType: UserType;
  reCaptchaToken?: string;
}

export interface IRegisterResponse {
  success: boolean;
}

export interface IRegisterError {
  message: string;
  code?: string;
}

export type IRegisterFormValues = z.infer<typeof registerSchema>;
